import { useEffect, useState } from "react";

const EVENTS = ["pointerdown", "pointermove", "keydown", "touchstart", "scroll", "wheel"] as const;

/**
 * Becomes true as soon as the visitor does anything (move, tap, scroll, type).
 *
 * Used to postpone non-critical work — extra data fetches and the re-render
 * they cause — until after the page is painted and interactive, which keeps
 * the main thread free during the first seconds of the visit.
 */
export function useFirstInteraction(): boolean {
  const [interacted, setInteracted] = useState(false);

  useEffect(() => {
    if (interacted) return;
    const onInteract = () => setInteracted(true);
    EVENTS.forEach((event) =>
      window.addEventListener(event, onInteract, { passive: true, once: true }),
    );
    return () => EVENTS.forEach((event) => window.removeEventListener(event, onInteract));
  }, [interacted]);

  return interacted;
}
